import { render, staticRenderFns } from "./repairT.vue?vue&type=template&id=012db59c&scoped=true&"
import script from "./repairT.vue?vue&type=script&lang=js&"
export * from "./repairT.vue?vue&type=script&lang=js&"
import style0 from "./repairT.vue?vue&type=style&index=0&id=012db59c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012db59c",
  null
  
)

export default component.exports